/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetaResponse } from '../../models/meta-response';

export interface MetaGet$Plain$Params {
}

export function metaGet$Plain(http: HttpClient, rootUrl: string, params?: MetaGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MetaResponse>> {
  const rb = new RequestBuilder(rootUrl, metaGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MetaResponse>;
    })
  );
}

metaGet$Plain.PATH = '/api/v1/platform/meta';
